import i18next from 'i18next';

/** ORDER */
export const getChoicesForAvailabilityDropdown = () => [
  {
    id: 1,
    name: i18next.t('GENERAL.AVAILABLE_ORDER'),
    itemValue: true,
  },
  {
    id: 2,
    name: i18next.t('GENERAL.UNAVAILABLE_ORDER'),
    itemValue: false,
  },
];

/** STOCK */
export const getChoicesForStockDropdown = () => [
  {
    id: 1,
    name: i18next.t('GENERAL.AVAILABLE_STOCK'),
    itemValue: true,
  },
  {
    id: 2,
    name: i18next.t('GENERAL.UNAVAILABLE_STOCK'),
    itemValue: false,
  },
];

/** LOSSES */
export const getChoicesForDlcLossDropdown = () => [
  {
    id: 1,
    name: i18next.t('GENERAL.AVAILABLE_LOSS'),
    itemValue: true,
  },
  {
    id: 2,
    name: i18next.t('GENERAL.UNAVAILABLE_LOSS'),
    itemValue: false,
  },
];

/** TRANSFER */
export const getChoicesForTransferDropdown = () => [
  {
    id: 1,
    name: i18next.t('GENERAL.AVAILABLE_TRANSFER'),
    itemValue: true,
  },
  {
    id: 2,
    name: i18next.t('GENERAL.UNAVAILABLE_TRANSFER'),
    itemValue: false,
  },
];
